const appStates = {
  acquiringAbout: {
    name: 'AcquiringAbout',
    path: '/acquiring/about'
  },
  acquiringDemoProducts: {
    name: 'AcquiringDemoProducts',
    path: '/acquiring/products'
  },
  acquiringDocuments: {
    name: 'AcquiringDocuments',
    path: '/acquiring/documents'
  },
  acquiringPaymentInfo: {
    name: 'AcquiringPaymentInfo',
    path: '/acquiring/payment/info'
  },
  acquiringPaymentResult: {
    name: 'AcquiringPaymentResult',
    path: '/acquiring/payment/result'
  },
  buyoutBalance: {
    name: 'BuyoutBalance',
    path: '/balance'
  },
  buyoutPayment: {
    name: 'buyoutPayment',
    path: '/:sourceId/:buyoutId/invoices/:invoiceId/pay'
  },
  buyoutPaymentConfirmation: {
    name: 'buyoutPaymentConfirmation',
    path: '/:sourceId/:buyoutId/invoices/:invoiceId'
  },
  buyoutPickupPointSet: {
    name: 'BuyoutItemPickupPointSet',
    path: '/sources/:sourceId/buyouts/:buyoutId/pickupPoint/set'
  },
  messagePermissions: {
    name: 'MessagePermissions',
    path: '/message/permissions'
  },
  needPay: {
    name: 'NeedPay',
    path: '/error/needPay'
  },
  sourceList: {
    name: 'SourceList',
    path: '/sources'
  },
  sourceItemContent: {
    name: 'SourceItemContent',
    path: '/sources/:sourceId/buyouts'
  },
  sourceItemBuyoutItem: {
    name: 'SourceItemBuyoutItem',
    path: '/sources/:sourceId/buyouts/:buyoutId'
  },
  sourceItemEventList: {
    name: 'SourceItemEventList',
    path: '/sources/:sourceId/events'
  },
  sourceItemSettings: {
    name: 'SourceItemSettings',
    path: '/sources/:sourceId/settings'
  },
  sourceItemUserProfile: {
    name: 'SourceItemUserProfile',
    path: '/sources/:sourceId/user/profile'
  },
  userProfile: {
    name: 'UserProfile',
    path: '/user/profile'
  }
}

const isSharedState = (currentStateName) => currentStateName === appStates.acquiringAbout.name
  || currentStateName === appStates.acquiringDemoProducts.name
  || currentStateName === appStates.acquiringDocuments.name
  || currentStateName === appStates.acquiringPaymentInfo.name
  || currentStateName === appStates.acquiringPaymentResult.name

const ccy = {
  EUR: {
    id: 'EUR',
    sign: '€',
    title: 'Евро (EUR)'
  },
  GBP: {
    id: 'GBP',
    sign: '£',
    title: 'Фунт стерлингов (GBP)'
  },
  RUB: {
    id: 'RUB',
    sign: '₽',
    title: 'Рубли (RUB)'
  },
  TRY: {
    id: 'TRY',
    sign: '₺',
    title: 'Турецкие лиры, (TRY)'
  },
  UAH: {
    id: 'UAH',
    sign: '₴',
    title: 'Гривны (UAH)'
  },
  USD: {
    id: 'USD',
    sign: '$',
    title: 'Доллары США (USD)'
  }
}

const codeRussia = '+7'
const codeBelarus = '+375'
const codeUkraine = '+380'
const phone = {
  codes: [codeRussia, codeBelarus, codeUkraine],
  getLength: code => {
    switch (code) {
      case codeBelarus:
      case codeUkraine:
        return {
          model: 9,
          validation: 16
        }
      default:
        return {
          model: 10,
          validation: 19
        }
    }
  },
  getMask: code => {
    switch (code) {
      case codeRussia:
        return {
          input: '(###) ### - ## - ##',
          output: '##########'
        }
      case codeBelarus:
      case codeUkraine:
        return {
          input: '## ### - ## - ##',
          output: '#########'
        }
      default:
        return {
          input: '',
          output: ''
        }
    }
  }
}

const status = {
  delivery : {
    admin: {
      id: 'admin',
      title: 'У организатора'
    },
    pickupPoint: {
      id: 'pickupPoint',
      title: 'На точке выдачи'
    },
    customer: {
      id: 'customer',
      title: 'У клиента'
    }
  },

  transaction: {
    done: {
      id: 'done',
      class: 'green',
      icon: 'mdi-plus',
      title: 'Завершена'
    },
    reject: {
      id: 'reject',
      class: 'reject red',
      icon: 'mdi-cancel',
      title: 'Отклонена организатором'
    },
    hold: {
      id: 'hold',
      icon: 'mdi-clock-outline',
      class: 'orange',
      title: 'Ожидает подтверждения организатора'
    }
  },

  payment: {
    all: {
      id: 'all',
      title: 'Все',
      icon: 'mdi-package-variant'
    },
    unpayed: {
      id: 'unpayed',
      title: 'Ожидает оплаты',
      icon: 'mdi-currency-usd-off',
      color: 'red'
    },
    needConfirm: {
      id: 'needConfirm',
      title: 'Оплачен, ожидает подтверждения',
      icon: 'mdi-account-clock',
      color: 'orange'
    },
    payed: {
      id: 'payed',
      title: 'Оплачен',
      icon: 'mdi-currency-usd',
      color: 'green'
    },
    prepayed: {
      id: 'prepayed',
      title: 'Предоплачен',
      icon: 'mdi-piggy-bank-outline',
      color: 'cyan'
    }
  },

  stock: {
    inStock: {
      id: 'inStock',
      icon: 'mdi-cart',
      title: 'Пришел',
      color: '#00e676'
    },
    partialStock: {
      id: 'partialStock',
      icon: 'mdi-cart',
      title: 'Пришел частично',
      color: '#ffa000'
    },
    outOfStock: {
      id: 'outOfStock',
      icon: 'mdi-cart-off',
      title: 'Не пришел',
      color: '#ff3d00'
    }
  },
}

const types = {
  balance: {
    group: 'group',
    personal: 'personal'
  },
  confirmation: {
    form: {
      id: 'form',
      title: 'Квитанция заполненная вручную'
    },
    image: {
      id: 'image',
      title: 'Фото квитанции'
    }
  },
  orders: {
    delivery: {
      id: 'delivery',
      icon: 'mdi-truck',
      title: 'Доставка'
    },
    discount: {
      id: 'discount',
      icon: 'mdi-sale',
      title: 'Скидка'
    },
    fee: {
      id: 'fee',
      icon: 'mdi-percent',
      title: 'Оргсбор'
    },
    total: {
      id: 'total',
      icon: 'mdi-plus',
      title: 'Увеличение цены заказа'
    },
    item: {
      id: 'item',
      icon: 'mdi-cart',
      title: 'Элемент заказа'
    },
    office: {
      id: 'office',
      icon: 'mdi-store',
      title: 'Офис'
    }
  },
  events: {
    changeBuyoutStatus: {
      id: 'changeBuyoutStatus',
      icon: 'mdi-update'
    },
    fullPaymentSuccess: {
      id: 'fullPaymentSuccess',
      icon: 'mdi-check-all'
    },
    paymentSuccess: {
      id: 'paymentSuccess',
      icon: 'mdi-check-all'
    },
    prepaymentSuccess: {
      id: 'prepaymentSuccess',
      icon: 'mdi-check-all'
    },
    verifyBuyoutItem: {
      id: 'verifyBuyoutItem',
      icon: 'mdi-cart-arrow-down'
    }
  },
  paymentInfo: {
    account: {
      id: 'account',
      icon: 'mdi-bank',
      title: 'Рассчетный счет'
    },
    card: {
      id: 'card',
      icon: 'mdi-credit-card-outline',
      title: 'Банковская карта'
    },
    cash: {
      id: 'cash',
      icon: 'mdi-cash',
      title: 'Наличные'
    },
    phone: {
      id: 'phone',
      icon: 'mdi-phone',
      title: 'Номер телефона (сбер онлайн или СБП)'
    }
  },
  receipts: {
    'sale': 'Приход',
    'revert': 'Возврат',
    payments: {
      'card': 'По карте',
      'cash': 'Наличными',
      'prepaid': 'Предоплата',
      methods: {
        'full_prepayment': 'Полная предоплата',
        'prepayment': 'Частичная предоплата',
        'advance': 'Аванс',
        'full_payment': 'Полная оплата',
        'partial_payment': 'Частичная оплата',
        'credit': 'В кредит',
        'credit_payment': 'Оплата кредита'
      },
      objects: {
        'commodity': 'Товар',
        'excise': 'Подакцизный товар',
        'job': 'Работа',
        'service': 'Услуга',
        'gambling_bet': 'Ставка азартной игры',
        'gambling_prize': 'Выигрыш азартной игры',
        'lottery': 'Лотерейный билет',
        'lottery_prize': 'Выигрыш лотереи',
        'intellectual_activity': 'Предоставление результатов интеллектуальной деятельности',
        'payment': 'Платеж',
        'agent_commission': 'Агентское вознаграждение',
        'composite': 'Составной предмет расчета',
        'another': 'Иной предмет расчета',
        'property_right': 'Имущественное право',
        'sales_tax': 'Торговый сбор',
        'resort_fee': 'Курортный сбор'
      }
    }
  },
  sno: {
    'psn': 'ПСН',
    'usn_income': 'УСН Доходы',
    'usn_income_outcome': 'УСН Доходы - Расходы',
  },
  widget: {
    buyoutsConfigurable: {
      id: 'buyoutsConfigurable',
      title: 'Список закупок'
    }
  }
}

export {
  appStates,
  isSharedState,
  ccy,
  phone,
  status,
  types
}
